import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量删除选中项")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认")

import { ref, nextTick } from "vue";
import {
  getWareToolPage,
  addWareTool,
  editWareTool,
  deleteWareTool
} from "@/service/main/gauge/recipient";
import { ElMessage, ElMessageBox } from "element-plus";
import { exportExcel } from "@/utils/exportExcel";
import Pagination from "@/components/Pagination/index.vue";
import {  statusEnum} from "@/utils/enum";
import { formatUtcToData } from "@/utils/formate";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
//查询
const formModel = ref({
  Name: "",
  status: "",
  PageNo: 1,
  PageSize: 10
});
//仓库类型列表
let tableData = ref([]);
//列表的数据条数
const totalItems = ref<number>(0);

//获取菜单列表
const getTabelData = () => {
  getWareToolPage(formModel.value)
    .then((res) => {
      console.log(res);
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        tableData.value = result.rows;
        totalItems.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${res.message}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(err);
    });
};

getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    Name: "",
    status: "",
    PageNo: 1,
    PageSize: 10
  };
  getTabelData();
};

//选中的行
const checkRows = ref<{ id: number }[]>([]);

// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    account: "用户名",
    name: "姓名",
    nickName: "工号",
    email: "邮箱",
    phone: "手机号",
    status: "状态"
  };
  exportExcel(checkRows.value, entozh, "xlsx", "工量具领用人信息表");
};

//批量删除
const handleBatchDelete = () => {
  const handleArr: number[] = [];
  checkRows.value.forEach((item) => {
    handleArr.push(item.id);
  });
  const obj = { id: handleArr };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareTool(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};
//删除
const deleteRole = (id: number) => {
  const obj = { id: [id] };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareTool(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//操作表单ref
const dialogRef = ref();

//打开窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = "add";
  } else {
    dialogType.value = "edit";
    addForm.value = Object.assign({}, scope);
  }
  dialogVisible.value = true;
  nextTick(() => {
    dialogRef.value.clearValidate();
  });
};
//添加/编辑
let addForm = ref({
  createdTime: "",
  updatedTime: "",
  createdUserId: "",
  createdUserName: "",
  account: "",
  name: "",
  nickName: "",
  email: "",
  phone: "",
  status: 0
});

//rules
const formRules = {
  account: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
  name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
  nickName: [{ required: true, message: "工号不能为空", trigger: "blur" }],
  email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
  phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }]
};

//操作提交
const confirm = () => {
  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      addForm.value.createdUserId = store.state.login.userInfo.id;
      addForm.value.createdUserName = store.state.login.userInfo.name;
      addForm.value.createdTime = formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      );
      addForm.value.updatedTime = formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      );
      if (dialogType.value == "add") {
        addWareTool(addForm.value)
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("添加成功");
              getTabelData();
              dialogVisible.value = false;
            } else {
              ElMessage.error(`${res.code}:${res.message}`);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        editWareTool(addForm.value)
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("编辑成功");
              getTabelData();
              dialogVisible.value = false;
            } else {
              ElMessage.error(`${res.code}:${res.message}`);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      ElMessage.warning("表单验证失败");
    }
  });
};

//关闭窗口
const closeDialog = () => {
  addForm.value = {
    createdTime: "",
    updatedTime: "",
    createdUserId: "",
    createdUserName: "",
    account: "",
    name: "",
    nickName: "",
    email: "",
    phone: "",
    status: 0
  };
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入姓名"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "用户名",
            prop: "account",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "姓名",
            prop: "name",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "工号",
            prop: "nickName",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "邮箱",
            prop: "email",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "手机号",
            prop: "phone",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "启用状态",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                type: scope.row.status == 0 ? 'success' : 'info'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.status == 0 ? "启用" : "冻结"), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "260px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                onClick: ($event: any) => (deleteRole(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '新增领用人员' : '编辑领用人员',
      width: "50%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用户名:",
                      prop: "account"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).account,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addForm).account) = $event)),
                          clearable: "",
                          placeholder: "请输入用户名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "姓名:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).name) = $event)),
                          clearable: "",
                          placeholder: "请输入姓名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工号:",
                      prop: "nickName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).nickName,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).nickName) = $event)),
                          clearable: "",
                          placeholder: "请输入工号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "邮箱:",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).email,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).email) = $event)),
                          clearable: "",
                          placeholder: "请输入邮箱"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "手机号:",
                      prop: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).phone,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).phone) = $event)),
                          clearable: "",
                          placeholder: "请输入手机号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "状态:",
                      prop: "status"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).status,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).status) = $event)),
                          placeholder: "请选择状态",
                          size: "la rge",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})